export const REGISTER_STEPS = Object.freeze({
	READ_POSITION: 0,
	READ_PACKAGES_OR_POSITION: 1,
});
